import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';

import { addSnackbar } from 'theSource/components/Snackbar';

interface ShareParams {
  files: File[];
  title?: string;
  text?: string;
  onFallback?: () => void;
}

export interface UseWebShareResult {
  share: () => void;
  canShare: boolean | null;
}

export const useWebShare = ({
  files,
  title,
  text,
}: ShareParams): UseWebShareResult => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [canShare, setCanShare] = useState<boolean | null>(null);

  useEffect(() => {
    setCanShare(Boolean(navigator?.canShare?.({ files })));
  }, [setCanShare, files]);

  const share = () => {
    if (!Boolean(files)) {
      return;
    }

    if (canShare) {
      navigator.share({ files, title, text }).catch((e: Error) => {
        if (e.name !== 'AbortError') {
          dispatch(
            addSnackbar({
              message: t('common:shareError'),
              severity: 'error',
            })
          );
        }
      });
      return;
    }
  };

  return {
    share,
    canShare,
  };
};
